import { Col, Form, Row } from "react-bootstrap";
import { HeaderRegister } from "../../../components/HeaderRegister";
import { MinimumValuePickupJustifyJustificationService } from "../../../services/minimumvaluepickupjustifyjustification.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { Formik } from "formik";
import * as yup from 'yup';
import { MinimumValuePickupJustifyJustificationModel } from "../../../models/minimumvaluepickupjustifyjustification.model";
import storageService from "../../../services/storage.service";

export const MinimumValuePickupJustifyJustificationRegister = () => {
  const { id } = useParams<{id?: string}>();
  const [initialValues, setInitialValues] = useState<MinimumValuePickupJustifyJustificationModel>({
    id: 0,
    justification: ''
  });
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef();
  const history = useHistory();

  const initialize = async () => {
    if (Number(id)) {
      const response: any = await MinimumValuePickupJustifyJustificationService.getById(id);
      if (response.success) {
        setInitialValues(response.result);
      }
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const schema = yup.object().shape({
    justification: yup.string().required(t('REQUIRED')).max(150, t('MINIMUM_VALUE_PICKUP_JUSTIFY.FULLNAME_MAX_LENGTH'))
    });

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  }

  const user = storageService.getUser();

  const saveTransporter = (transporter: MinimumValuePickupJustifyJustificationModel) => {
    setLoading(true);
    if (transporter.id > 0) {
      MinimumValuePickupJustifyJustificationService.update(transporter).then((response: any) => {
        if (response.success) {
          ToastService.success(t('MINIMUM_VALUE_PICKUP_JUSTIFY.UPDATED'));
          history.push('/parameter/minimumvaluepickupjustifyjustification');
        }
      }).finally(() => {
        setLoading(false);
      });
    } else {
      MinimumValuePickupJustifyJustificationService.insert(transporter).then((response: any) => {
        if (response.success) {
          ToastService.success(t('MINIMUM_VALUE_PICKUP_JUSTIFY.INSERTED'));
          history.push('/parameter/minimumvaluepickupjustifyjustification');
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  return (
    <>
      <HeaderRegister title={`${t('MENU_EQUIPMENT_APPROVAL_JUSTIFICATION')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} path={"/parameter/minimumvaluepickupjustifyjustification"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <Formik
        enableReinitialize={true} 
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          saveTransporter(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row className="align-items-center">
                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='justification'
                          id='justification'
                          type='text'
                          placeholder={t('MINIMUM_VALUE_PICKUP_JUSTIFY.JUSTIFICATION')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.justification && !!errors.justification}
                          value={values.justification}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.justification}
                        </Form.Control.Feedback>
                        <Form.Label>{t('MINIMUM_VALUE_PICKUP_JUSTIFY.JUSTIFICATION')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
       )}
      </Formik>
    </>
  );
};
